// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2_pUe","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3BwNX","gfeWrapper":"CalendarEvent_gfeWrapper__3CRrr"};